import { Icon } from '@synergy/icons';
import { Button, Col, Flex, Form, Row } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { createField } from '../../../../../../../../utils/hooks/FieldsFactory';

const TransitionContainer = styled.div`
  transition: all 0.3s ease-in-out;
  overflow: hidden;
  height: 0;
  opacity: 0;

  &.visible {
    height: auto;
    opacity: 1;
  }
`;

const PeerContainer = styled.div`
  transition: transform 0.3s ease-in-out;
  transform: ${({ showWeight }) => (showWeight ? 'translateY(0)' : 'translateY(100%)')};
`;

const ItemCreateRelationForm = ({ form, handleSwitch, recordsToShowInForm, showWeight, isLoading }) => {
    const { t } = useTranslation();

    return (
        <Row gutter={16} style={{ width: "100%" }}>
            <Col span={13}>
                <Flex vertical gap={10}>
                    {createField(form, recordsToShowInForm.Parent, t)}

                    <Flex justify='center' align='center'>
                        <Button shape='circle' size='large' onClick={handleSwitch}>
                            <Icon icon="ArrowSwitch" iconsize="md" color="blue-4" />
                        </Button>
                    </Flex>
                    {createField(form, recordsToShowInForm.Child, t)}
                </Flex>
            </Col>

            <Col span={11}>
                <Flex vertical gap={10} justify='space-between' style={{ height: "100%" }} align='center'>
                    <Flex vertical align='center' flex={1} gap={10} >
                        <PeerContainer showWeight={showWeight}>
                            <Flex vertical align='center'>
                                {createField(form, recordsToShowInForm.IsPeer, t)}
                            </Flex>
                        </PeerContainer>
                        <TransitionContainer className={showWeight ? 'visible' : ''}>
                            {showWeight && createField(form, recordsToShowInForm.Weight, t)}
                        </TransitionContainer>
                    </Flex>
                    <Form.Item style={{ width: "50%" }} >
                        <Button type="primary" htmlType="submit" style={{ width: "100%" }} loading={isLoading}>
                            {t('create')}
                        </Button>
                    </Form.Item>
                </Flex>
            </Col>
        </Row >
    )
}


export default ItemCreateRelationForm;